import { AppState } from '@/context/types';
import { Flatten, FormTrucker } from '@/types';
import { deepFind, isEmpty } from '@/utils';

export const useTruckerAutoFillVerify =
  (state: AppState) =>
  (path: keyof Flatten<FormTrucker>): boolean => {
    const { data: profile } = state.truckerProfile;

    if (!profile.profileId && !profile.riskId) return false;
    return !isEmpty(deepFind(profile, path));
  };
